module.exports = __webpack_public_path__ + "img/filter-welcome-background-cjdr.f9519f72.jpg";